import * as React from 'react';
import { TimeClock } from '../TimeClock';
import { jsx as _jsx } from "react/jsx-runtime";

var isTimePickerView = function isTimePickerView(view) {
  return view === 'hours' || view === 'minutes' || view === 'seconds';
};

export var renderTimeViewClock = function renderTimeViewClock(_ref) {
  var view = _ref.view,
      onViewChange = _ref.onViewChange,
      views = _ref.views,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      className = _ref.className,
      classes = _ref.classes,
      disableFuture = _ref.disableFuture,
      disablePast = _ref.disablePast,
      minTime = _ref.minTime,
      maxTime = _ref.maxTime,
      shouldDisableTime = _ref.shouldDisableTime,
      shouldDisableClock = _ref.shouldDisableClock,
      minutesStep = _ref.minutesStep,
      ampm = _ref.ampm,
      ampmInClock = _ref.ampmInClock,
      components = _ref.components,
      componentsProps = _ref.componentsProps,
      slots = _ref.slots,
      slotProps = _ref.slotProps,
      readOnly = _ref.readOnly,
      disabled = _ref.disabled,
      sx = _ref.sx,
      autoFocus = _ref.autoFocus,
      showViewSwitcher = _ref.showViewSwitcher,
      disableIgnoringDatePartForTimeValidation = _ref.disableIgnoringDatePartForTimeValidation;
  return /*#__PURE__*/_jsx(TimeClock, {
    view: view,
    onViewChange: onViewChange,
    views: views.filter(isTimePickerView),
    value: value,
    defaultValue: defaultValue,
    onChange: onChange,
    className: className,
    classes: classes,
    disableFuture: disableFuture,
    disablePast: disablePast,
    minTime: minTime,
    maxTime: maxTime,
    shouldDisableTime: shouldDisableTime,
    shouldDisableClock: shouldDisableClock,
    minutesStep: minutesStep,
    ampm: ampm,
    ampmInClock: ampmInClock,
    components: components,
    componentsProps: componentsProps,
    slots: slots,
    slotProps: slotProps,
    readOnly: readOnly,
    disabled: disabled,
    sx: sx,
    autoFocus: autoFocus,
    showViewSwitcher: showViewSwitcher,
    disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation
  });
};